// src/api/school.js
import request from '@/utils/request'

// api接口列表
const api = {
	list: 'volunteer/pool/list',
	chooseMajor: 'volunteer/pool/major',
	region: 'university/region',
	type: 'enrollment/type',
	university: 'university/type',
	majors: 'major/tree',
	batch: 'volunteer/batch',
	mode: 'region_mode_info',
	recommend: 'recommend/volunteer/count',
	years: 'exam/years',
	pool: 'volunteer/pool/svip_list',
	mylist: 'volunteer/form',
	creat: 'volunteer/form/save',
	edit: 'volunteer/form/edit',
	add: 'volunteer/add',
	delete: 'volunteer/form/delete',
	deleteP: 'volunteer/delete',
	sort: 'volunteer/change/sort',
	jump: 'volunteer/jump/sort',
	percent: 'volunteer/percent',
	volList: 'volunteer/items',
	confirm: 'volunteer/confirm',
	exportForm: 'volunteer/export',
	count: 'volunteer/pool/count',
	intelligent: 'volunteer/intelligent/generation',
	used: 'volunteer/use',
	selected: 'volunteer/selected',
	status: 'volunteer/user/status',
	update: 'examinfo/update/score',
	special: 'special/conditions',
	specialAdd: 'add/special/conditions',
	vipOption: 'volunteer/query/config'
}

// 列表
export function list(data) {
	return request({
		url: api.list,
		method: 'post',
		data
	})
}

// 查看可选专业
export function chooseMajor(data) {
	return request({
		url: api.chooseMajor,
		method: 'post',
		data
	})
}

//  智能填报筛选条件--院校位置
export function region(params) {
	return request({
		url: api.region,
		method: 'get',
		params
	})
}

// 智能填报筛选条件--招生类型
export function type(params) {
	return request({
		url: api.type,
		method: 'get',
		params
	})
}

// 智能填报筛选条件--院校类型 
export function university(params) {
	return request({
		url: api.university,
		method: 'get',
		params
	})
}

// 智能填报筛选条件--专业
export function majors(params) {
	return request({
		url: api.majors,
		method: 'get',
		params
	})
}

// 智能填报筛选条件--批次 
export function batch(params) {
	return request({
		url: api.batch,
		method: 'get',
		params
	})
}

// 根据高考省份id获取高考模式信息
export function mode(params) {
	return request({
		url: api.mode,
		method: 'get',
		params
	})
}

// 获取推荐的志愿数量
export function recommend(params) {
	return request({
		url: api.recommend,
		method: 'get',
		params
	})
}

// 高考年份
export function years(params) {
	return request({
		url: api.years,
		method: 'get',
		params
	})
}

// 我的志愿表列表
export function pool(data) {
	return request({
		url: api.pool,
		method: 'post',
		data
	})
}

// 我的志愿表列表
export function mylist(data) {
	return request({
		url: api.mylist,
		method: 'post',
		data
	})
}

// 创建志愿表 
export function creat(data) {
	return request({
		url: api.creat,
		method: 'post',
		data
	})
}

export function edit(data) {
	return request({
		url: api.edit,
		method: 'post',
		data
	})
}

export function add(data) {
	return request({
		url: api.add,
		method: 'post',
		data
	})
}

// 删除志愿表
export function del(data) {
	return request({
		url: api.delete,
		method: 'post',
		data
	})
}

// 删除志愿
export function deleteP(data) {
	return request({
		url: api.deleteP,
		method: 'post',
		data
	})
}

// 上下排序
export function sort(data) {
	return request({
		url: api.sort,
		method: 'post',
		data
	})
}

// 跳转排序
export function jump(data) {
	return request({
		url: api.jump,
		method: 'post',
		data
	})
}


// 进度等
export function percent(params) {
	return request({
		url: api.percent,
		method: 'get',
		params
	})
}

// 志愿项列表
export function volList(params) {
	return request({
		url: api.volList,
		method: 'get',
		params
	})
}

// 志愿表确认
export function confirm(data) {
	return request({
		url: api.confirm,
		method: 'post',
		data
	})
}


// 导出
export function exportForm(params) {
	return request({
		url: api.exportForm,
		method: 'get',
		params
	})
}

// 智能生成数量
export function count(data) {
	return request({
		url: api.count,
		method: 'post',
		data
	})
}


// 智能生成
export function intelligent(data) {
	return request({
		url: api.intelligent,
		method: 'post',
		data
	})
}

// 切换志愿表使用状态
export function used(data) {
	return request({
		url: api.used,
		method: 'post',
		data
	})
}

// 当前志愿表已选的志愿
export function selected(params) {
	return request({
		url: api.selected,
		method: 'get',
		params
	})
}

// 用户状态和志愿数量  
export function status(params) {
	return request({
		url: api.status,
		method: 'get',
		params
	})
}

// 修改高考成绩
export function update(data) {
	return request({
		url: api.update,
		method: 'post',
		data
	})
}

// 特殊条件
export function special(params) {
	return request({
		url: api.special,
		method: 'get',
		params
	})
}

// 添加特殊条件
export function specialAdd(data) {
	return request({
		url: api.specialAdd,
		method: 'post',
		data
	})
}

// vip智能生成筛选条件
export function vipOption(params) {
	return request({
		url: api.vipOption,
		method: 'get',
		params
	})
}